/******/ (() => { // webpackBootstrap
class ScrollingBanner extends HTMLElement {
  constructor() {
    super();
    this.duplicatedLinks = this.querySelectorAll('ol[data-duplicated] a');
    this.sectionElement = null;
    this.isSticky = false;
    this.throttleTimeout = null;
    this.headerHeight = this.getHeaderHeight();
  }

  getHeaderHeight() {
    // Спробуємо знайти header елемент і отримати його висоту
    const header = document.querySelector('.site-header, .header-section header');
    if (header) {
      return header.offsetHeight || 90;
    }
    return 90; // fallback значення
  }

  connectedCallback() {
    this.init();
    this.initStickyScroll();
  }

  init() {
    this.duplicatedLinks.forEach(link => {
      link.setAttribute('tabindex', '-1'); //prevents focusing on a duplicated link on keyboard nav
    });
  }

  initStickyScroll() {
    // Знаходимо батьківський shopify-section елемент з header-group
    this.sectionElement = this.closest('.shopify-section-group-header-group');
    
    if (!this.sectionElement) {
      console.warn('ScrollingBanner: Could not find parent shopify-section-group-header-group element');
      return;
    }

    // Додаємо обробник скролу з throttling
    this.handleScroll = this.throttle(this.handleScroll.bind(this), 16); // ~60fps
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    
    // Виконуємо перевірку одразу при ініціалізації
    this.handleScroll();
  }

  throttle(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    }
  }

  handleScroll() {
    if (!this.sectionElement) return;

    const scrollY = window.scrollY;
    const sectionRect = this.sectionElement.getBoundingClientRect();
    const sectionOffsetTop = scrollY + sectionRect.top;
    
    // Елемент стає липким, коли скрол досягає позиції елементу мінус висота header
    const shouldBeSticky = scrollY > (sectionOffsetTop - this.headerHeight);

    if (shouldBeSticky && !this.isSticky) {
      this.makeSticky();
    } else if (!shouldBeSticky && this.isSticky) {
      this.removeSticky();
    }
  }

  makeSticky() {
    if (this.sectionElement) {
      this.sectionElement.classList.add('scrolling-banner');
      this.isSticky = true;
    }
  }

  removeSticky() {
    if (this.sectionElement) {
      this.sectionElement.classList.remove('scrolling-banner');
      this.isSticky = false;
    }
  }

  disconnectedCallback() {
    // Видаляємо обробник подій при знищенні компонента
    if (this.handleScroll) {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }

}

// Only define the custom element if it doesn't already exist
if (!customElements.get('scrolling-banner')) customElements.define('scrolling-banner', ScrollingBanner);

/******/ })()
;